<template>
  <div class="container">
    <h2>Acceso clientes</h2>
    <form @submit.prevent="login">
      <InputText id="mail" label="Correo electrónico" v-model="email" @keyup="cleanErrorMessage()" />
      <InputText id="password" label="Contraseña" type="password" v-model="password" @keyup="cleanErrorMessage()" />
      <p v-show="errorMessage" class="error-label">{{ errorMessage }}</p>
      <label> <input type="checkbox" /> Recordar acceso </label>
      <Button id="ingresar" class="mt-35" type="submit" text="Ingresar" classtype="primary" />
    </form>
    <router-link class="mt-35" :to="{ name: 'Reestablecer' }">¿No recuerdas tu contraseña?</router-link>
  </div>
</template>
<script setup>
import { ref } from "vue"
import { useAuthStore } from "@/store"

import Button from "../components/Button.vue"
import InputText from "../components/InputText.vue"
import { OK } from "@/helpers/"

const email = ref("")
const password = ref("")
const authStore = useAuthStore()
const errorMessage = ref("")

const cleanErrorMessage = () => {
  errorMessage.value = ""
  document.querySelector("#ingresar").disabled = false
}

const login = () => {
  localStorage.setItem("testLS", JSON.stringify({ ls: "working" }))
  authStore
    .login({ email: email.value, password: password.value })
    .then((response) => {
      if (response.result != OK) errorMessage.value = response.message
    })
    .catch((err) => {
      console.log(err, "wrong data")
    })
}
</script>
<style>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

form {
  min-width: 300px;
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 15px;
}

label {
  margin-top: 15px;
}
</style>
